class LogEntry {
    actionDate: Date;
    dataID: number;
    isDeleted: boolean;
    isNew: boolean;
    message: string;
    username: string;

    constructor(data?: Partial<LogEntry>) {
        Object.assign(this, data);

        if (typeof this.actionDate === "string")
            this.actionDate = new Date(this.actionDate);
    }
}

export default LogEntry;